export default "__VITE_ASSET__CsGSCEgW__"